<template>
  <div class="container">
    <div class="row">
      <div class="col-12">
        <h1>Add Barber</h1>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <b-card class="mt-3">
          <b-row>
            <b-col md="6" offset-md="3">
              <resource-form @submit="submit"></resource-form>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import ResourceForm from './ResourceForm';

export default {
  components: {
    ResourceForm
  },
  methods: {
    ...mapActions({
      createResource: 'resources/createResource'
    }),
    async submit(resource) {
      try {
        await this.createResource(resource);
        this.$notify({
          type: 'success',
          text: 'Barber added'
        });
        this.$router.push({ name: 'resources' });
      } catch (e) {
        this.$notify({
          type: 'error',
          title: 'Error',
          text: e.message
        });
      }
    }
  }
};
</script>
